export default "__VITE_ASSET__a0261be9__"